<section class="au-comments-section">
	<p class="section-label">{{ 'comments' | translate }}</p>

	<div class="comments-list">
		{{ resetLastDate() }}
		@for (comment of commentsList | sortDate: 'created'; track comment) {
			<div class="comment-item-wrapper">
				@if (shouldShowSeparator(comment.created)) {
					<div class="separator">
						<div class="date-divider"></div>
						<div>{{ comment.created | dateAgo: false }}</div>
						<div class="date-divider"></div>
					</div>
				}
				<comment-item
					[requester]="requester"
					[comment]="comment"
					(deleteCommentPressed)="deleteComment.emit({ commentId: $event })"
					(editCommentSubmitted)="editComment.emit($event)"
				/>
			</div>
		}
	</div>
</section>
